import { API } from './config'

export const getUpcomingClasses = () =>
  API.get(`/calendar/upcoming`)
    .then((res) => res.data.data)
    .catch(() => false)
